import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import Tooltip from '../Tooltip/Tooltip';

/**
Testo che mostra i "tre puntini" se supera lo spazio assegnato e il testo completo nella tooltip.
*/
const EllipsisText = ({
  className, children, left, top, disabled, numberOfLines,
}) => {
  const ref = useRef();
  const textClassname = cns('ellipsis__text', className, { 'ellipsis__text--multilines': numberOfLines > 1 });
  const textStyle = numberOfLines > 1 ? { WebkitLineClamp: numberOfLines } : undefined;

  return (
    <Tooltip
      content={children}
      left={left}
      top={top}
      right={!left}
      enableFunction={() => !disabled && ref.current && (
        (ref.current.offsetWidth < ref.current.scrollWidth)
        || (ref.current.offsetHeight < ref.current.scrollHeight)
      )}
      className="ellipsis__info-tooltip"
    >
      <span className={textClassname} ref={ref} style={textStyle}>
        {children}
      </span>
    </Tooltip>
  );
};

EllipsisText.propTypes = {
  /**
   * Classe custom.
   */
  className: PropTypes.string,
  /** Contenuto da renderizzare all'interno del componente */
  children: PropTypes.node,
  /** Indica se aprire il tooltip spostato verso sinistra */
  left: PropTypes.bool,
  /** Mostra il tooltip sopra */
  top: PropTypes.bool,
  /** Permette di disabilitare il tooltip */
  disabled: PropTypes.bool,
  /** Numero di linee su cui visualizzare il testo */
  numberOfLines: PropTypes.number,
};

EllipsisText.defaultProps = {
  className: undefined,
  children: null,
  left: false,
  top: true,
  disabled: false,
  numberOfLines: 1,
};

export default EllipsisText;
